import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { IActionItem } from 'interfaces/actionMenu.interfaces';
import menuItems from 'common/messages/menuItems';
import ActionItem from 'common/components/ActionsMenu/ActionItem';

const useStyles = makeStyles({
  icon: {
    width: 16,
    height: 16,
  },
});

const ActionItemDelete: FC<IActionItem> = ({ key = 'delete', onClick, disabled = false }) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <ActionItem
      key={key}
      icon={<Delete className={classes.icon} />}
      onClick={onClick}
      disabled={disabled}
    >
      {intl.formatMessage(menuItems.delete)}
    </ActionItem>
  );
};

export default ActionItemDelete;
